import { IList } from 'annotation-tools/utils';
import { IAnnotationType } from '../../../types/record/annotation';
import { uri } from '../../api-endpoint';
import { IAnnotationFromAPISuccessResponse } from '../../type-conversion/annotation/from-api-repsonse';
import { AnnotationAPIRawSuccessResponseType } from '../../types/annotation/api-response';
import { FetchResultType } from '../../types/common/fetch-result';
import {
  defaultErrorResponseConverter,
  errorResponseConverterGenerator
} from '../common/base/fetch/error-response-converter-generator';
import { fetchJsonWithTokenCheck } from '../common/base/fetch/fetch-json-with-token-check';
import { mapFetchResult } from '../common/base/fetch/map-fetch-result';
import {
  RawDetailErrorType,
  RawNonFieldErrorsType
} from '../common/base/fetch/types/common-error-type';

type RawSuccessResponseType = AnnotationAPIRawSuccessResponseType[];
type RawErrorResponseType = RawDetailErrorType | RawNonFieldErrorsType;

const successResponseConverter = (
  annotations: AnnotationAPIRawSuccessResponseType[]
): IList<IAnnotationType> =>
  IList<IAnnotationType>(annotations.map(IAnnotationFromAPISuccessResponse));

const errorResponseConverter = errorResponseConverterGenerator(
  defaultErrorResponseConverter
);

export const executeInference = (token: string) => async (
  projectId: number,
  imageId: number
) => {
  const result = await fetchJsonWithTokenCheck({
    token,
    uri: uri.projectImagePredict(projectId, imageId),
    method: 'POST',
    body: undefined
  });

  return mapFetchResult(
    result as FetchResultType<RawSuccessResponseType, RawErrorResponseType>,
    successResponseConverter,
    errorResponseConverter
  );
};
